import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import {
  CmsComponentData,
  ContentHeaderComponentData,
  ImageLoadingStrategy,
} from '@boels/models';
import { MediaComponent } from '../media/media.component';

@Component({
  selector: 'boels-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss'],
  imports: [FontAwesomeModule, CommonModule, MediaComponent],
})
export class ContentHeaderComponent {
  @Input() componentData: CmsComponentData<ContentHeaderComponentData>;
  faChevronDown = faChevronDown;
  lazy = ImageLoadingStrategy.LAZY;

  scroll(el: HTMLElement): void {
    el.scrollIntoView({
      behavior: 'smooth',
    });
  }
}
